// extracted by mini-css-extract-plugin
export default {"pulsatingDotForAiSubtitles":"RkCbv_h8Xg5MbBMoN8IP","pulsatingDotForCopyStyles":"zUPlZ8O7ib59qVE8JUZr"};